import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { GodsviewService } from './godsview.service';
import { Router } from '@angular/router';
import { Paho } from 'ng2-mqtt/mqttws31';
import { Observable, Subscription } from 'rxjs';
import { CommunicationService } from '../communication.service';

import { ConfigService } from '../../config.service';
declare var google: any;
declare var moment: any;
declare var $: any;
declare var toastr: any;
declare var mapboxgl: any;
declare var L: any;
import * as myGlobals from '../../globals';

@Component({
    selector: 'app-godsview',
    templateUrl: './godsview.component.html',
    styleUrls: ['./godsview.component.css']
})
export class GodsviewComponent implements OnInit, OnDestroy {
    _client: Paho.MQTT.Client;
    fixed_navbar = false;
    options: FormGroup;
    all_drivers_index = [];
    all_drivers = [];
    moment: any;
    online_count = 0;
    offline_count = 0;
    logged_count = 0;
    inactive_count = 0;
    busy_count = 0;
    map: any;
    all_markers = [];
    offline_markers = [];
    online_markers = [];
    inactive_markers = [];
    loggedout_markers = [];
    busy_markers = [];
    showing_driver: any;
    show_search = false;
    search_done = false;
    selectedStatus = 3;
    online$: Observable<boolean>;
    onlineMarkersArray = [];
    onlineGroup: any;
    offlineGroup: any;
    busyGroup: any;
    inactiveGroup: any;
    loggedoutGroup: any;
    allCities = [];
    roleChannel: any;
    showLoader = true;
    lastChannelId: any;
    cityID: any;
    searchTerm: any;
    searchLocationMarker: any;
    operatorId: any;
    clusterGroup: any;
    subscription: Subscription;

    constructor(fb: FormBuilder, private _godsviewservice: GodsviewService,
        private _router: Router, private _conf: ConfigService, private _communicate: CommunicationService) {
        console.log(_router.url);
        // this.online$ = Observable.merge(
        //     Observable.of(navigator.onLine),
        //     Observable.fromEvent(window, 'online').mapTo(true),
        //     Observable.fromEvent(window, 'offline').mapTo(false)
        // )
        this.options = fb.group({
            'fixed': false,
            'top': 0,
            'bottom': 0,
        });
        this.subscription = this._communicate.getMessage().subscribe(message => { this.changeCity(message); })
    }
    private onfalied(): void {
        console.log('Connected to broker.');
    }
    private onConnected(): void {
        // alert();
        this._client.subscribe('storeOrders/' + sessionStorage.getItem('storeId'), { qos: 2 });
    }

    mqttConnection(chn) {
        this.lastChannelId = chn;
        console.log('gfdjgdjfk', this.lastChannelId)
        let onSuccess = () => {
            !this.lastChannelId ? this.lastChannelId = '' : this.lastChannelId = `${this.lastChannelId}/`;
            !this.roleChannel ? this.roleChannel = '' : this.roleChannel = `${this.roleChannel}/`;
            console.log('connected', 'godsview/' + this.lastChannelId + this.roleChannel + '/#');
            this._client.subscribe('godsview/' + this.lastChannelId + this.roleChannel + '#', { qos: 2 });
        }
        const optionsmqtt = {
            userName: myGlobals.MQTT_USERNAME,
            password: myGlobals.MQTT_PASSWORD,
            useSSL: myGlobals.MQTT_USESSL,
            timeout: 60,
            keepAliveInterval: 15,
            // Gets Called if the connection has successfully been established
            onSuccess: onSuccess,
            // Gets Called if the connection could not be established
            onFailure: (message) => {
                console.log('Connection failed:.' + message.errorMessage);
            }
        };
        this._client = new Paho.MQTT.Client(myGlobals.MQTT_HOST, "myClientId" + new Date().getTime());
        if (this._client && this._client.isConnected()) {
            !this.lastChannelId ? this.lastChannelId = '' : this.lastChannelId = `${this.lastChannelId}/`;
            !this.roleChannel ? this.roleChannel = '' : this.roleChannel = `${this.roleChannel}/`;
            this._client.unsubscribe(
                'godsview/' + this.lastChannelId + this.roleChannel + '#', {
                onSuccess: (message) => {
                    console.log('Connection failed:.' + message.errorMessage);
                },
            }
            );
            this._client.disconnect();
        }
        this._client.onConnectionLost = (responseObject: Object) => {
            console.log('disconnected--->', responseObject);
            let options = {
                userName: myGlobals.MQTT_USERNAME,
                password: myGlobals.MQTT_PASSWORD,
                useSSL: myGlobals.MQTT_USESSL,
                timeout: 60,
                keepAliveInterval: 15,
                cleanSession: true,
                // Gets Called if the connection has successfully been established
                onSuccess: () => {
                    if (responseObject['errorCode'] !== 0) {
                        onSuccess();
                    }
                },

                // Gets Called if the connection could not be established
                onFailure: (message) => {
                    console.log('Connection failed:.' + message.errorMessage);
                }
            }

            if (this._client && this._client.isConnected()) {
                console.log('connected', this._client.isConnected());
                !this.lastChannelId ? this.lastChannelId = '' : this.lastChannelId = `${this.lastChannelId}/`;
                !this.roleChannel ? this.roleChannel = '' : this.roleChannel = `${this.roleChannel}/`;
                this._client.unsubscribe(
                    'godsview/' + this.lastChannelId + this.roleChannel + '#', {
                    onSuccess: (message) => {
                        console.log('Connection failed:.' + message.errorMessage);
                    },
                }
                );
                this._client.disconnect();
                this._client.connect(options);
            }
            else {
                console.log('sdfvdbbdfvbdf', options)
                this._client.connect(options);
            }
            // console.log("client connected", this._client.isConnected())
            // this._client.isConnected() ? '' : this._client.isConnected();
            //    / toastr['error']('<h5>MQTT stopped due to internal server error</h5>');
        };
        this._client.onMessageArrived = (message: Paho.MQTT.Message) => {
            this.changeDriverStatus(JSON.parse(message.payloadString));
        };
        this._client.isConnected() ? '' : this._client.connect(optionsmqtt);
    }

    map_load() {

        const input = document.getElementById('pac-input');
        const autocomplete = new google.maps.places.Autocomplete(input);
        autocomplete.addListener('place_changed', () => {
            this.clearSearchLocationDetails();
            var place = autocomplete.getPlace();
            const lat = place.geometry.location.lat();
            const long = place.geometry.location.lng();
            if (place.geometry.location.lat()) {
                this.searchLocationMarker = L.marker([lat, long]).addTo(this.map);
                this.map.setView([lat, long], 14);
            }
        })
    }

    clearSearchLocationDetails() {
        if (this.searchLocationMarker != undefined) {
            this.map.removeLayer(this.searchLocationMarker);
        }
    }

    clearSearchInputField() {
        $('#pac-input').val('');
    }

    side() {
        this.fixed_navbar = !this.fixed_navbar;
    }
    updateUrl($event) {
        $event.target.src = 'https://image.flaticon.com/icons/svg/1581/1581908.svg';
    }
    smoothZoom(map, max, cnt) {
        if (cnt >= max) {
            return;
        } else {
            const z = google.maps.event.addListener(map, 'zoom_changed', (event) => {
                google.maps.event.removeListener(z);
                this.smoothZoom(map, max, cnt + 1);
            });
            setTimeout(() => { this.map.setZoom(cnt); }, 100);
        }
    }
    changeDrivercountDec(oldStatus, id, currentStatus) {
        switch (oldStatus) {
            case 3:
                this.online_count--;
                break;
            case 4:
                this.offline_count--;
                break;
            case 8:
                this.inactive_count--;
                break;
            case 9:
                this.logged_count--;
                break;
            case 5:
                this.busy_count--;
                break;
        }
        if (this.showing_driver.id == id) {
            this.showing_driver = []
        }
        if (this.selectedStatus == currentStatus) {

            // hide of marker if same index view is showing
            this.addMapmarker(status, id);
        }
    }
    changeDriverStatusInc(data, oldStatus) {
        const status = data.status;
        switch (status) {
            case 3:
                this.online_count++;
                break;
            case 4:
                this.offline_count++;
                break;
            case 8:
                this.inactive_count++;
                break;
            case 9:
                this.logged_count++;
                break;
            case 5:
                this.busy_count++;
                break;
        }
        if (this.selectedStatus != status && this.selectedStatus == oldStatus) {
            // hide of marker if same index view is showing
            this.hideMapmarker(status, data.driverId);
        }
    }
    sliderMove() {
        // this.showing_driver = [];
        if ($('#right_slider').hasClass('active')) {
            $('#right_slider').removeClass('active');
        } else {
            $('#right_slider').addClass('active');
        }
    }

    addMapmarker(status, id) {
        this._godsviewservice.getalldrivers({
            'driverId': id,
            'cityId': '',
            'search': '',
            'operatorId': '',
        }).subscribe((res: any) => {
            this.all_drivers.push(res.data.driverArr[0]);
            const marker = L.marker([res.data.driverArr[0].location.latitude, res.data.driverArr[0].location.longitude]);
            marker.id = id;
            this.all_markers.push(marker);
            this.onlineMarkersArray.push(marker);
            this.clusterGroup.addLayer(marker);
            this.map.addLayer(this.clusterGroup);
        })
    }

    hideMapmarker(status, driverid) {
        const indexOfcurrent = this.onlineMarkersArray.findIndex(i => i.id == driverid);
        this.clusterGroup.removeLayer(this.onlineMarkersArray[indexOfcurrent]);
        // this.map.removeLayer(this.onlineMarkersArray[indexOfcurrent]);
        this.onlineMarkersArray.splice(indexOfcurrent, 1);
        this.all_drivers.splice(indexOfcurrent, 1);
    }

    changeDrivercountInc(data) {
        // const status = data.status;
        const driverid = data.driverId;
        const indexOfcurrent = this.onlineMarkersArray.findIndex(i => i.id == driverid);
        // this.onlineMarkersArray[indexOfcurrent].status = status;
        if (indexOfcurrent != -1) {
            if (data.location !== undefined) {
                var newLatLng = new L.LatLng(data.location.latitude, data.location.longitude);
                this.onlineMarkersArray[indexOfcurrent].setLatLng(newLatLng);
            }
            if (this.showing_driver !== undefined && this.showing_driver !== '') {
                if (this.showing_driver.id == driverid) {
                    this.map.panTo(this.onlineMarkersArray[indexOfcurrent].getLatLng());
                }
            }
        }
        else {
            const indexOfcurrent2 = this.all_markers.findIndex(i => i.id == driverid);
            var newLatLng = new L.LatLng(data.location.latitude, data.location.longitude);
            this.all_markers[indexOfcurrent2].setLatLng(newLatLng);
        }
    }
    changeDriverStatus(data) {
        console.log(data);
        // if status is not 100 then its status update 
        // if status is 100 then its location or device update
        if (data.status != 100) {
            // status update
            this.getDriversCount(this.cityID);
            if (this.driverWithoutStatus[data.driverId] !== data.status) {
                this.changeDrivercountDec(this.driverWithoutStatus[data.driverId], data.driverId, data.status);
                this.changeDriverStatusInc(data, this.driverWithoutStatus[data.driverId]);
                this.driverWithoutStatus[data.driverId] = data.status;
            }
            const index = this.all_drivers.findIndex(i => i.id === data.driverId);
            console.log('"""""Status update"""', this.all_drivers, index);
            if (index != -1 && data.deviceType) {
                console.log('data updated!! 1');
                this.all_drivers[index].mobileDevices.appversion = data.appversion;
                this.all_drivers[index].mobileDevices.batteryPercentage = data.batteryPercentage;
                this.all_drivers[index].mobileDevices.locationCheck = data.locationCheck;
                this.all_drivers[index].mobileDevices.deviceType = data.deviceType;
                this.all_drivers[index].lastSeen = moment().unix();
                this.all_drivers[index].lastseentime = moment.utc(this.all_drivers[index].lastSeen * 1000).fromNow();
                // this.all_drivers[index].location.latitude = data.location.latitude;
                // this.all_drivers[index].location.longitude = data.location.longitude;
                if (data.location !== undefined) {
                    // console.warn(`this.all_drivers[index].location`, this.all_drivers[index].location);
                    this.all_drivers[index].location = data.location;
                    // console.warn(`this.all_drivers[index].location --> after`, this.all_drivers[index].location);
                }
                const indexOfcurrent2 = this.onlineMarkersArray.findIndex(i => i.id === data.driverId);
                if (indexOfcurrent2 != -1 && data.location != undefined) {
                    // const { latitude, longitude } = data.location;
                    // console.log(indexOfcurrent2);
                    var newLatLng = new L.LatLng(data.location.latitude, data.location.longitude);
                    this.onlineMarkersArray[indexOfcurrent2].setLatLng(newLatLng);
                }

                // this.changeDrivercountInc(data);
                // this.getDriversCount(this.cityID);
                // console.log(this.clusterGroup);
                // this.refreshNew();
                this.clusterGroup.refreshClusters();
            } else {
                // console.log('elaer');
                // TODO: NEED To rewrite
                // if (data.status == this.selectedStatus) {
                //     this.all_drivers.push(data);
                //     this.getDriversCount(this.cityID);
                //     this.addMapmarker(data.status, data.driverId);
                // }
            }
        } else {
            // location or device update
            const index = this.all_drivers.findIndex(i => i.id == data.driverId);
            if (index != -1 && data.deviceType) {
                console.log('data updated!! 2');
                this.all_drivers[index].mobileDevices.appversion = data.appversion;
                this.all_drivers[index].mobileDevices.batteryPercentage = data.batteryPercentage;
                this.all_drivers[index].mobileDevices.locationCheck = data.locationCheck;
                this.all_drivers[index].mobileDevices.deviceType = data.deviceType;
                this.all_drivers[index].lastSeen = moment().unix();
                this.all_drivers[index].lastseentime = moment.utc(this.all_drivers[index].lastSeen * 1000).fromNow();
                this.changeDrivercountInc(data);
                this.clusterGroup.refreshClusters();
            }
        }
        this.all_drivers = this.all_drivers.filter(function (item, pos, self) {
            return self.indexOf(item) == pos;
        });
    }

    getdriverjobs(driver) {
        this._godsviewservice.getdriverjobs({
            id: driver.id
        }).subscribe((res: any) => {
        },
            err => {
                if (err.status == 401) {
                    this._router.navigate(['login']);
                } else {
                    this.intervalError();
                }
            });
    }
    getdriverDetails(driver) {
        // this.map.setZoom(18);
        this.clearSearchInputField();
        this.clearSearchLocationDetails();
        this.showing_driver = driver;
        let marker;
        for (let inst = 0; inst < this.onlineMarkersArray.length; inst++) {
            if (this.onlineMarkersArray[inst].id == driver.id) {
                var content = '<p style="text-align:center"><strong>' + driver.name + '</strong> <br> <img width="50" height="50" src="' + driver.profilePic + '" alt=""></p>';
                marker = this.onlineMarkersArray[inst];
                marker.bindPopup(content);
                break;
            }
        }
        this.map.panTo(marker.getLatLng());
        marker.openPopup();
        setTimeout(() => {
            this.map.setZoom(18);
        }, 100);
    }
    refreshNew() {
        this.all_drivers = [];
        this.all_markers = [];
        this.showLoader = true;
        this.showing_driver = [];
        this.clearSearchInputField();
        if (this.onlineGroup) {
            this.onlineGroup.eachLayer((layer) => {
                this.map.removeLayer(layer);
            })
        }
    }

    driverWithoutStatus = [];
    allDrivers(cityId) {
        this._godsviewservice.getalldrivers({
            'driverId': "",
            'cityId': this.cityID,
            'search': this.searchTerm,
            'operatorId': this.operatorId,
        }).subscribe((res: any) => {
            for (let inst = 0; inst < res.data.driverArr.length; inst++) {
                this.driverWithoutStatus[res.data.driverArr[inst].id] = res.data.driverArr[inst].status;
            }
        })
    }

    showalldrivers(cityId) {
        this.all_drivers = [];
        this.all_markers = [];
        this.showLoader = true;
        this.showing_driver = [];
        this.clearSearchInputField();
        if (this.onlineGroup) {
            this.onlineGroup.eachLayer((layer) => {
                this.map.removeLayer(layer);
            })
        }
        this.clearSearchLocationDetails();
        this._godsviewservice.getdriverBasedStatus({
            'driverId': "",
            'cityId': this.cityID,
            'search': this.searchTerm,
            'operatorId': this.operatorId,
            'status': this.selectedStatus
        }).subscribe((res: any) => {
            this.map.removeLayer(this.clusterGroup);
            this.clusterGroup = new L.MarkerClusterGroup({
                disableClusteringAtZoom: 17
            });
            console.log('alldriver', res)
            this.refreshNew();
            let drivers;
            switch (this.selectedStatus) {
                case 3: drivers = res.data.onlineDrivers;
                    break;
                case 4: drivers = res.data.offlineDrivers;
                    break;
                case 5: drivers = res.data.busyDrivers;
                    break;
                case 8: drivers = res.data.inActiveDrivers;
                    break;
                case 9: drivers = res.data.loggedOutDrivers;
                    break;
            }
            for (let inst = 0; inst < drivers.length; inst++) {
                drivers[inst].lastseentime = moment.utc(drivers[inst].lastSeen * 1000).fromNow();
                this.all_drivers.push(drivers[inst]);
                let icn;
                let allmarker;
                let marker;
                if (drivers[inst].status == 3) {
                    icn = '/assets/images/active.png';
                } else if (drivers[inst].status == 8) {
                    icn = '/assets/images/inactive.png';
                } else if (drivers[inst].status == 9) {
                    icn = '/assets/images/loggedout.png';
                } else if (drivers[inst].status == 5) {
                    icn = '/assets/images/loggedout.png';
                }
                const isVehicleImageIsPresent = drivers[inst].vehicleDetail.vehicleMapIcon;
                if (isVehicleImageIsPresent) {
                    var myIcon = L.icon({
                        iconUrl: drivers[inst].vehicleDetail.vehicleMapIcon,
                        iconSize: [60, 70]
                    });
                    marker = L.marker([drivers[inst].location.latitude, drivers[inst].location.longitude], { icon: myIcon });
                } else {
                    marker = L.marker([drivers[inst].location.latitude, drivers[inst].location.longitude]);
                }
                var content = '<p><strong>' + drivers[inst].name + '</strong></p><img src="" alt="">';
                marker.bindPopup(content);
                marker.id = drivers[inst].id;
                marker.status = drivers[inst].status;
                this.onlineMarkersArray.push(marker);
                this.clusterGroup.addLayer(marker);
                this.map.addLayer(this.clusterGroup);
                allmarker = L.marker([drivers[inst].location.latitude, drivers[inst].location.longitude]);
                allmarker.id = drivers[inst].id;
                allmarker.status = drivers[inst].status;
                marker = L.marker([drivers[inst].location.latitude, drivers[inst].location.longitude]);
                this.all_markers.push(allmarker);
                this.all_drivers_index.push(drivers[inst].id);
                this.changeLastseen();
                this.search_done = false;
            }
            this.showLoader = false;
        },
            err => {
                this.showLoader = false;
                if (err.status == 401) {
                    this._router.navigate(['login']);
                } else {
                    this.intervalError();
                }
            });
    }
    selectedIndexChange(e) {
        this.onlineMarkersArray = [];
        if (this.clusterGroup) {
            this.clusterGroup.eachLayer((layer) => {
                this.map.removeLayer(this.clusterGroup);
            })
        }
        this.map.removeLayer(this.clusterGroup);
        this.showing_driver = [];
        const bounds = new google.maps.LatLngBounds();
        let statusNumber = 0;
        if (e == 0) {  // show only online markers
            statusNumber = 3;
            this.selectedStatus = 3;
            this.showalldrivers(this.cityID);
            // } else if (e === 1) {  // show only offline markers
            //     statusNumber = 4;
            //     this.selectedStatus = 4;
            //     this.showalldrivers(this.cityID);
            // } else if (e == 1) {  // show only inactive markers --- removed as busy is not availble
            //     statusNumber = 5;
            //     this.selectedStatus = 5;
            //     this.showalldrivers(this.cityID);
        } else if (e == 1) {  // show only loggedout markers
            statusNumber = 8;
            this.selectedStatus = 8;
            this.showalldrivers(this.cityID);
        } else if (e == 2) {  // show only loggedout markers
            statusNumber = 9;
            this.selectedStatus = 9;
            this.showalldrivers(this.cityID);
        }
        //  this.showalldrivers(this.cityID);
        let groupMarkers = [];
        // for (let i = 0; i < this.all_markers.length; i++) {
        //     if (this.all_markers[i].status == this.selectedStatus) {
        //         this.onlineMarkersArray.push(this.all_markers[i]);
        //         this.onlineGroup = L.featureGroup(this.onlineMarkersArray).addTo(this.map);
        //     }
        // }

        // this.map.fitBounds(bounds);
    }

    getDriversCount(cityId) {
        this._godsviewservice.getdriverCount({
            'driverId': "",
            'cityId': this.cityID || cityId,
            'search': this.searchTerm,
            'operatorId': this.operatorId,
            'status': this.selectedStatus
        }).subscribe((res: any) => {
            this.online_count = res.data.driverCount.online;
            this.offline_count = res.data.driverCount.offline;
            this.busy_count = res.data.driverCount.busy;
            this.inactive_count = res.data.driverCount.inActive;
            this.logged_count = res.data.driverCount.loggedOut;
        },
            err => {
                this.showLoader = false;
                if (err.status == 401) {
                    this._router.navigate(['login']);
                } else {
                    this.intervalError();
                }
            });
    }
    zoomIn() {
        let zoomLevel = this.map.getZoom();
        zoomLevel++;
        this.map.setZoom(zoomLevel);
    }
    zoomOut() {
        let zoomLevel = this.map.getZoom();
        zoomLevel--;
        this.map.setZoom(zoomLevel);
    }

    show_search_blck() {
        // if (this.search_done) {
        // this.showalldrivers(0);
        // }
        // $("#mat-tab-label-0-0").trigger('click');
        this.show_search = !this.show_search;
        setTimeout(() => {
            $('#search_input').focus();
        }, 300);
    }
    close_search_blck() {
        this.show_search = !this.show_search;
        this.searchTerm = '';
        // this.changeCity(0);
    }
    emptyAll() {
        this.all_markers = [];
        this.all_drivers_index = [];
        this.all_markers = [];
        this.all_drivers = [];
        this.online_count = 0;
        this.offline_count = 0;
        this.inactive_count = 0;
        this.logged_count = 0;
    }
    searchDriversInput(e) {
        this.searchTerm = e.target.value;
        // this.changeCity(0);
        this.showalldrivers(this.cityID);
    }
    searchDriversInput1(e) {
        if (e.target.value !== '') {
            this._godsviewservice.searchDrivers({
                search: e.target.value,
            }).subscribe((res: any) => {
                this.emptyAll();
                if (res.data.length > 0) {
                    const drivers = res.data;
                    const bounds = new google.maps.LatLngBounds();
                    for (let inst = 0; inst < drivers.length; inst++) {
                        drivers[inst].lastseentime = moment.utc(drivers[inst].lastSeen * 1000).fromNow();
                        this.all_drivers.push(drivers[inst]);
                        let icn;
                        if (drivers[inst].status == 3) {
                            this.online_count++;
                            icn = '/assets/images/active.png';
                            // } else if (drivers[inst].status === 4) {
                            //     this.offline_count++;
                            //     icn = '/assets/images/offline.png';
                        } else if (drivers[inst].status == 8) {
                            this.inactive_count++;
                            icn = '/assets/images/inactive.png';
                        } else if (drivers[inst].status == 9) {
                            this.logged_count++;
                            icn = '/assets/images/loggedout.png';
                        }
                        const marker = new google.maps.Marker({
                            position: new google.maps.LatLng(drivers[inst].location.latitude, drivers[inst].location.longitude),
                            title: '',
                            icon: icn
                        });
                        marker.id = drivers[inst].id;
                        marker.status = drivers[inst].status;
                        if (drivers[inst].status == 3) {
                            marker.setMap(this.map);
                        }
                        bounds.extend(new google.maps.LatLng(drivers[inst].location.latitude, drivers[inst].location.longitude));
                        this.map.fitBounds(bounds);
                        this.all_markers.push(marker);
                        this.all_drivers_index.push(drivers[inst].id);
                        this.search_done = true;
                    }
                }
            },
                err => {
                    if (err.status == 401) {
                        this._router.navigate(['login']);
                    } else {
                        this.intervalError();
                    }
                });
        }
    }
    changeLastseen() {
        setInterval(() => {
            for (let inst = 0; inst < this.all_drivers.length; inst++) {
                this.all_drivers[inst].lastSeen = this.all_drivers[inst].lastSeen;
                this.all_drivers[inst].lastseentime = moment.utc(this.all_drivers[inst].lastSeen * 1000).fromNow();
            }
        }, 10000);
    }
    intervalError() {
        toastr['error']('<h5>Could not connect to server!!! Will try to connect after 30 seconds automatically please hang on</h5>');
        setInterval(() => {
            this.changeCity(0);
            // this.map_load();
            // this.showalldrivers(0);
            // this.changeLastseen();
        }, 30000);
    }
    sessionExpire() {
        this._router.navigate(['login']);
    }
    curlat: any;
    curlong: any;
    initMapbox() {
        // let marker;

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(data => {
                console.log(data);
                this.curlat = data.coords.latitude;
                this.curlong = data.coords.longitude;
                this.map.setView([-28.4793, 24.6727], 8);
            });
        } else {
            $.get('https://ipapi.co/json/').always((res: any) => {
                if (res.status >= 400 || res.error) {
                    $.get('https://ipinfo.io', (response) => {
                        this.curlat = (response.loc).split(',')[0];
                        this.curlong = (response.loc).split(',')[1];
                        this.map.setView([-28.4793, 24.6727], 8);
                    }, 'jsonp');
                } else {
                    this.curlat = res.latitude;
                    this.curlong = res.longitude;
                    this.map.setView([-28.4793, 24.6727], 8);
                }
            });
        }
        L.mapbox.accessToken = 'pk.eyJ1IjoiZHVyZ2FwcmFzYWQxMTEiLCJhIjoiY2ppdmlmcTB6MjJnbjNrcnEwZTd6azA1bSJ9.5gpijQK778V_oNoO1Fr5Xw';
        const options = {
            minZoom: 10,
            maxZoom: 15
        }
        this.map = L.mapbox.map('googleMap')
            .setView([-28.4793, 24.6727], 8)
            .addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/streets-v11'));
        this.clusterGroup = new L.MarkerClusterGroup({
            disableClusteringAtZoom: 17
        });
        this.clusterGroup.on('clusterclick', (a) => {
            // a.layer is actually a cluster
        });
    }


    getAllCities() {
        // get all cities list
        //const role = sessionStorage.getItem('role');
        this._godsviewservice.getallcitiesList({}).subscribe((res: any) => {
            this.allCities = res.data.cityList;
            const role = res.data.operatorId;
            this.cityID = res.data.cityList[0].cityId;
            if (role == undefined || role == '' || role == null) {
                this.roleChannel = '';
                this.operatorId = '';
            } else {
                this.roleChannel = '/' + role;
                this.operatorId = role;
            }
            // this.showdriverbasedstatus(this.allCities[0].cityId);
            if (res.data.isAllcityAccess) {
                this.allDrivers(0);
                this.changeCity(0);
                // this.getDriversCount(0);
                // this.showalldrivers(0);
                // this.mqttConnection(0);
            }
            else {
                this.allDrivers(this.allCities[0].cityId);
                this.changeCity(this.allCities[0].cityId);
                // this.getDriversCount(this.allCities[0].cityId);
                // this.showalldrivers(this.allCities[0].cityId);
                // this.mqttConnection(this.allCities[0].cityId);
            }
        });
    }


    changeCity(value) {
        // if (event != 0) {
        //     this.cityID = event.target.value;
        // }
        console.log('value', value)
        this.cityID = value;
        this.getDriversCount(this.cityID);
        this.showalldrivers(this.cityID);
        this.mqttConnection(this.cityID);
    }
    ngOnInit() {
        // this.subscription = this._communicate.getMessage().subscribe(message => { this.changeCity(message); });
        $(".booking_buutns").hide();
        $("#back_button").show();
        if (this._conf.getItem('devtoken') != null) {
            setTimeout(() => {
                this.initMapbox();
                this.map_load();
            }, 200)
            toastr.options = {          // toast messages settings
                'newestOnTop': false,
                'positionClass': 'toast-top-right',
                'preventDuplicates': true,
                'onclick': null,
                'showDuration': '3000',
                'hideDuration': '1000',
                'timeOut': '6000',
                'extendedTimeOut': '1000',
                'showEasing': 'swing',
                'hideEasing': 'linear',
                'showMethod': 'fadeIn',
                'hideMethod': 'fadeOut',
            }
            // this.map_load();
            this.getAllCities();
        } else {
            this._router.navigate(['login']);
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
        console.log('Unsubscribed from Godsview Mqtt', 'godsview/', this.lastChannelId, this.roleChannel);
        if (this._client && this._client.isConnected() && this.lastChannelId && this.roleChannel) {
            this._client.unsubscribe('godsview/' + this.lastChannelId + this.roleChannel + '/#', null);
            this._client.disconnect();
        }
        // this._client.unsubscribe('godsview/' + this.lastChannelId + this.roleChannel + '/#', null);
    }
}
